import React, { useState, useEffect } from "react";
import { Button, Box } from "@mui/material";
import { followUniversity } from "../api/api";

const FollowButton = ({ universityId, isFollowing, onClick }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [followed, setFollowed] = useState(isFollowing);

  // Synchroniser `followed` avec la prop `isFollowing`
  useEffect(() => {
    setFollowed(isFollowing);
  }, [isFollowing]);

  const toggleFollow = async () => {
    const token = localStorage.getItem("authToken");
    const prevFollowed = followed;
    const newFollowedState = !followed;

    setIsLoading(true);
    setFollowed(newFollowedState); // Optimistic update

    try {
      const response = await followUniversity(universityId, token);
      if (!response.ok) {
        throw new Error("Abonnement non pris en compte");
      }
      // Mise à jour via la fonction du parent
      onClick();
    } catch (error) {
      console.error("Error abonnement:", error);
      setFollowed(prevFollowed); // Rollback si erreur
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box style={{ display: "flex", alignItems: "center" }}>
      <Button
       onClick={toggleFollow} 
       disabled={isLoading}>
        {followed ? "Abonné" : "S'abonner"}
      </Button>
    </Box>
  );
};

export default FollowButton;
